export class ImportacaoArquivoModel{
    constructor(
        public tpArquivo: number = 0,
        public nomeArquivo: string = '',
        public conteudoArquivo: string = ''
    ) {}
}